import { render, staticRenderFns } from "./_SecuritySymbol.vue?vue&type=template&id=6c581955"
import script from "./_SecuritySymbol.vue?vue&type=script&lang=js"
export * from "./_SecuritySymbol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,FauxTabs: require('/vercel/path0/components/FauxTabs.vue').default})
